import { SanityMapSection } from 'graphql-types';
import React, { useEffect, useState } from 'react';
import { useMapContext } from '../context/mapContext';
import { usePageContext } from '../context/pageContext';
import { Expert } from '../section/MapSection';
import * as styles from './mapCard.module.scss';
import { PractitionerCard } from './PractitionerCard';
import Arrow from '../../../static/svg/arrow-down-orange.svg';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  filteredResults: Expert[];
  section: SanityMapSection;
  open: boolean;
  setOpen: (open) => void;
}

export const MapCardsMobile: React.FC<Props> = ({ filteredResults, section, open, setOpen }) => {
  const { selected, setSelected } = useMapContext();
  const { lang, defaultLang } = usePageContext();
  const ref = React.createRef<HTMLDivElement>();

  useEffect(() => {
    if (typeof window !== 'undefined' && open) window.scrollTo(0, 0);
    if (open && selected) setSelected(undefined);
  }, [open]);

  return (
    <>
      <div className={styles.placeholder} />
      <div className={`${styles.wrapper} ${open && styles.open}`}>
        <div className={styles.tab}>
          <div
            onClick={() => {
              setOpen(!open);
            }}
          >
            <div className={`${styles.icon} ${open && styles.open}`}>
              <Arrow width={18} />
            </div>
            <h2>
              {findTranslation(section?._rawTitleMapSection, lang, defaultLang)}
              </h2>
          </div>
          <div className={styles.cards} ref={ref}>
            {filteredResults.map((item, index) => (
              <PractitionerCard
                key={`item-mobile-${index}`}
                data={item}
                onClick={() => {
                  setOpen(false);
                  setSelected(filteredResults[index]);
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
